export default {
  namespaced: true,

  state: () => ({
    users: {
      data: [],
      links: {},
      meta: {},
    },
    userGrowth: {
      statistic: [],
    },
    userActivity: {
      data: [],
    },
    filterList: [
      {
        title: '7 hari terakhir',
        value: 'week',
      },
      {
        title: '1 bulan terakhir',
        value: 'month',
      },
      {
        title: '1 tahun terakhir',
        value: 'year',
      },
    ],
    filterActive: {},
    filterUserActivityActive: {},
    tabTypeList: [
      {
        title: 'Buyer',
        value: 'buyer',
        color: 'success',
      },
      {
        title: 'Guest',
        value: 'guest',
        color: 'dark',
      },
    ],
    isLoading: false,
    isLoadingChart: false,
    isRegistryOwner: null,
  }),

  getters: {
    usersList: state => {
      const users = []
      state.users.data.forEach(el => {
        users.push({
          id: el.id,
          name: el.name,
          photo: el.photo,
        })
      })
      return users
    },
  },

  mutations: {
    SET_USER_LIST(state, payload) {
      state.users = payload
    },
    SET_USER_GROWTH(state, payload) {
      state.userGrowth = payload
    },
    SET_USER_ACTIVITY(state, payload) {
      state.userActivity = payload
    },
    SET_ACTIVE_FILTER(state, payload) {
      state.filterActive = payload
    },
    SET_ACTIVE_FILTER_USER_ACTIVITY(state, payload) {
      state.filterUserActivityActive = payload
    },
    RESET_USER_LIST(state) {
      state.users = {
        data: [],
        links: {},
        meta: {},
      }
    },
    SET_LOADING(state, payload) {
      state.isLoading = payload
    },
    SET_LOADING_CHART(state, payload) {
      state.isLoadingChart = payload
    },
  },

  actions: {
    async doNotChangeToInternal({ commit }, { id, dontSwitchExternalRegistry }) {
      try {
        const url = `/v1/admin/users/${id}/dont-switch-external-registry`

        commit('SET_LOADING', true)

        await this._vm.$http.put(url, {
          dont_switch_external_registry: dontSwitchExternalRegistry,
        })

        commit('SET_LOADING', false)
        return true
      } catch (e) {
        commit('SET_LOADING', false)
        return false
      }
    },
    async getUserList({ commit }, {
      page = null,
      keyword = undefined,
      type = undefined,
      isRegistryOwner = undefined,
      haveToken = undefined,
      hasSearch = false,
    } = {}) {
      try {
        if (!hasSearch) commit('SET_LOADING', true)
        const url = '/v1/admin/users'

        const response = await this._vm.$http.get(url, {
          params: {
            page,
            'filter[keyword]': keyword,
            'filter[type]': type,
            'filter[has_fcm_token]': haveToken,
            'filter[is_registry_owner]': isRegistryOwner,
          },
        })

        if (!hasSearch) commit('SET_USER_LIST', response.data)
        if (!hasSearch) commit('SET_LOADING', false)

        return response.data
      } catch (error) {
        if (!hasSearch) commit('SET_LOADING', false)
        return error
      }
    },
    async getUserGrowth({ commit, state }, {
      interval = 'week',
    }) {
      try {
        commit('SET_LOADING_CHART', true)

        const today = new Date()
        const nextweek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7)
        const nextMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate())
        const nextYear = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate())
        let endDate = ''

        switch (interval) {
          case 'month':
            endDate = nextMonth
            break
          case 'year':
            endDate = nextYear
            break
          default:
            endDate = nextweek
        }

        commit('SET_ACTIVE_FILTER', state.filterList.find(el => el.value === interval))

        const url = '/v1/backoffice/diagram/user_registration'

        const response = await this._vm.$http.get(url, {
          params: {
            'filter[start_date]': endDate,
            'filter[end_date]': today,
          },
        })

        commit('SET_USER_GROWTH', response.data.data)
        commit('SET_LOADING_CHART', false)

        return response.data.data
      } catch (error) {
        commit('SET_LOADING_CHART', false)
        throw new Error(error)
      }
    },
    async exportUsers({ commit }, {
      isRegistryOwner = undefined,
    }) {
      function formatDate(date) {
        if (date) {
          const myDate = new Date(date)
          const month = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun',
            'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'][myDate.getMonth()]
          return `${myDate.getDate()} ${month} ${myDate.getFullYear()}`
        }
        return ''
      }
      try {
        const url = 'v1/admin/export/users?filter[type]=buyer'

        const response = await this._vm.$http.get(url, {
          params: {
            'filter[type]': 'buyer',
            'filter[is_registry_owner]': isRegistryOwner,
          },
        })

        const users = response.data.data.rows

        const csv = [
          [
            'Id',
            'Nama',
            'Email',
            'Nomor Telepon',
            'Tanggal Registrasi',
          ],
          ...users.map(item => [
            item.user_id,
            item.name,
            item.email,
            item.phone,
            formatDate(item.registration_date),
          ]),
        ]
          .map(e => e.join(','))
          .join('\n')

        const anchor = document.createElement('a')
        anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`
        anchor.target = '_blank'
        anchor.download = 'PenggunaMiniapoly.csv'
        anchor.click()

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Error!',
        }, { root: true })
        return error
      }
    },
    async getChartUserRegistered({ commit, state }, {
      interval = 'year',
      type = 'user_registration',
      startDate = null,
      endDate = null,
    }) {
      try {
        commit('SET_LOADING_CHART', true)

        const today = new Date()
        const nextweek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7)
        const nextMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate())
        const nextYear = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate())
        let endDateFilter = ''
        let typeUser = 'user_registration'

        if (startDate && endDate) {
          endDateFilter = startDate
        } else {
          switch (interval) {
            case 'month':
              endDateFilter = nextMonth
              break
            case 'year':
              endDateFilter = nextYear
              break
            default:
              endDateFilter = nextweek
          }
        }

        switch (type) {
          case 'buyer':
            typeUser = 'user_registration'
            break
          case 'guest':
            typeUser = 'user_registration_guest'
            break
          default:
            typeUser = 'user_registration'
        }

        const filterActive = state.filterList.find(el => el.value === interval)
        if (filterActive) {
          commit('SET_ACTIVE_FILTER', filterActive)
        }

        const url = `/v1/backoffice/diagram/${typeUser}`

        let frequency = ''
        const startD = new Date(endDateFilter)
        const endD = (startDate && endDate) ? new Date(endDate) : today
        const diffTime = Math.abs(endD - startD)
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

        if (diffDays > 90) {
          frequency = 'monthly'
        }

        const response = await this._vm.$http.get(url, {
          params: {
            'filter[start_date]': endDateFilter,
            'filter[end_date]': (startDate && endDate) ? endDate : today,
            'filter[frequency]': frequency,
          },
        })

        commit('SET_USER_GROWTH', response.data.data)
        commit('SET_LOADING_CHART', false)

        return response.data.data
      } catch (error) {
        commit('SET_LOADING_CHART', false)
        throw new Error(error)
      }
    },
    async getChartUserActivity({ commit, state }, {
      interval = 'week',
    }) {
      try {
        commit('SET_LOADING_CHART', true)

        const today = new Date()
        const nextweek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7)
        const nextMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate())
        const nextYear = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate())
        let endDate = ''

        switch (interval) {
          case 'month':
            endDate = nextMonth
            break
          case 'year':
            endDate = nextYear
            break
          default:
            endDate = nextweek
        }

        commit('SET_ACTIVE_FILTER_USER_ACTIVITY', state.filterList.find(el => el.value === interval))

        const url = '/v1/backoffice/diagram/user-login-activity'

        const response = await this._vm.$http.get(url, {
          params: {
            'filter[start_date]': endDate,
            'filter[end_date]': today,
            // 'filter[frequency]': interval === 'year' ? 'monthly' : '',
          },
        })

        commit('SET_USER_ACTIVITY', response.data.data)
        commit('SET_LOADING_CHART', false)

        return response.data.data
      } catch (error) {
        commit('SET_LOADING_CHART', false)
        throw new Error(error)
      }
    },
  },
}
